// NOTE(mikcol): renamed to GestureMouseEvent so we don't shadow MouseEvent from dom typings
import GestureMouseEvent from './MouseEvent';
import GestureRecognizerState from './GestureRecognizerState';
var Gestures = /** @class */ (function () {
    // tslint:disable-next-line:no-this-assignment
    function Gestures(element) {
        var _this = this;
        // Canvas offset items.
        // Fixes mouse coordinate problems when there's a border or padding.
        this.stylePaddingLeft = null;
        this.stylePaddingTop = null;
        this.styleBorderLeft = null;
        this.styleBorderTop = null;
        // Some pages have fixed-position bars at the top or left of the page
        // They will mess up mouse coordinates and this fixes that
        this.htmlTop = 0;
        this.htmlLeft = 0;
        // start drag after move by...
        this.dragStartThreshold = 2;
        this.invertY = true; // makes origin bottom left.
        // desktop props
        this.mousePosX = 0;
        this.mousePosY = 0;
        this.mouseDownPosX = 0;
        this.mouseDownPosY = 0;
        this.mouseLastPosX = 0;
        this.mouseLastPosY = 0;
        this.isMouseDown = false;
        this.isMouseOver = false; // mouse is over the element
        this.isDragging = false;
        this.isWheeling = false;
        this.isDoubleClick = false;
        this.doubleClickTiming = 300;
        // NOTE(mikcol): legacy used null instead of undefined
        this.wheelTimer = undefined;
        // touch props
        this.isDoubleTap = false;
        this.touchPosX = 0;
        this.touchPosY = 0;
        this.mouseDownTimestamp = 0;
        this.lastMouseDownTimestamp = 0;
        this.elapsedMouseDownTimestamp = 0;
        // Gesture Callbacks
        // NOTE(mikcol): removed comments in favor of types
        this.onTap = null;
        this.onDoubleTap = null;
        this.onLongPress = null;
        this.onPinch = null;
        // NOTE(mikcol): legacy comment used this shape for onPan:
        // { x_loc, y_loc, x_trans, y_trans, gestureState }
        this.onPan = null;
        // NOTE(mikcol): was not included in legacy, most likely doesn't matter
        this.onPointerHover = undefined;
        // Mouse Callbacks
        this.onMouseMove = null;
        this.onMouseDown = null;
        this.onMouseUp = null;
        this.onMouseClick = null;
        this.onMouseDoubleClick = null;
        this.onMouseDrag = null;
        this.onMouseDragStart = null;
        this.onMouseDragStop = null;
        this.onMouseWheel = null;
        this.onMouseOver = null;
        this.onMouseOut = null;
        // Touch Callbacks
        this.onTouchStart = null;
        this.onTouchMove = null;
        this.onTouchEnd = null;
        // activeTouches =
        //      touch.identifier -> touch
        this.activeTouchesMap = null;
        // The current mouse event
        this.event = null;
        this.stylesValid = false;
        this.totalOffset = null;
        this.element = element;
        if ('ontouchstart' in document || window.navigator.maxTouchPoints > 0) {
            this.element.ontouchstart = this.touchToMouse;
            this.element.ontouchmove = this.touchToMouse;
            this.element.ontouchend = this.touchToMouse;
            this.element.ontouchleave = this.touchToMouse;
        }
        // desktop events
        // document
        document.onmouseup = function (evt) {
            if (_this.isMouseDown) {
                if (evt.preventDefault) {
                    evt.preventDefault();
                }
                _this.isMouseDown = false;
                _this.doMouseEvent(evt);
            }
        };
        document.onmousemove = function (evt) {
            if (_this.isDragging) {
                if (evt.preventDefault) {
                    evt.preventDefault();
                }
                _this.doMouseEvent(evt);
            }
        };
        // element
        this.element.addEventListener('mousedown', function (evt) {
            // if (evt.preventDefault) {
            //     evt.preventDefault();
            // }
            _this.isMouseDown = true;
            _this.doMouseEvent(evt);
        }, false);
        this.element.addEventListener('mousemove', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            // NOTE(mikcol): was using this instead of self in legacy, but we killed self
            if (_this.isMouseDown) {
                _this.isDragging = true;
            }
            _this.doMouseEvent(evt);
        }, false);
        this.element.addEventListener('mouseup', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            if (_this.isMouseDown) {
                _this.isMouseDown = false;
                _this.doMouseEvent(evt);
            }
        }, false);
        this.element.addEventListener('mouseover', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            _this.isMouseOver = true;
            _this.doMouseEvent(evt);
        }, false);
        this.element.addEventListener('mouseout', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            _this.isMouseOver = false;
            _this.doMouseEvent(evt);
        }, false);
        this.element.addEventListener('mousewheel', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            _this.doMouseEvent(evt);
        }, false);
        // Mozilla mouse wheel
        this.element.addEventListener('DOMMouseScroll', function (evt) {
            if (evt.preventDefault) {
                evt.preventDefault();
            }
            _this.doMouseEvent(evt);
        }, false);
    }
    Gestures.prototype.doMouseEvent = function (domEvent) {
        if (!domEvent) {
            domEvent = window.event;
        }
        // copy the DOM event because its props are readonly
        // later we mixin our MouseEvent props and will need to change
        // the type property. Can't do that if we don't make this clone.
        // tslint:disable-next-line:no-object-literal-type-assertion
        var domCopy = {};
        // NOTE(mikcol): keeping legacy behavior here (forin with no filtering)
        // tslint:disable-next-line:forin
        for (var key in domEvent) {
            domCopy[key] = domEvent[key];
        }
        // create the event (mixin our gtl MouseEvent props with DOM event)
        // but do not modify the original domEvent
        for (var mouseProp in GestureMouseEvent) {
            if (MouseEvent.hasOwnProperty(mouseProp)) {
                if (!domCopy[mouseProp]) {
                    domCopy[mouseProp] = GestureMouseEvent[mouseProp];
                }
            }
        }
        var event = (this.event = domCopy);
        event.isMouseOverCanvas = this.isMouseOver;
        // save last mouse position
        this.mouseLastPosX = this.mousePosX;
        this.mouseLastPosY = this.mousePosY;
        // get new position
        this.setMousePosition(domEvent, event);
        // get offset from last position
        event.deltaX = event.x - this.mouseLastPosX;
        event.deltaY = event.y - this.mouseLastPosY;
        if (domEvent.type === GestureMouseEvent.MOUSE_MOVE) {
            if (this.isMouseDown || this.isDragging) {
                event.buttonDown = true;
            }
            if (this.isMouseDown) {
                // get the distance dragged from mouse down point
                event.dragDeltaX = event.x - this.mouseLastPosX;
                event.dragDeltaY = event.y - this.mouseLastPosY;
                event.buttonDown = true;
                // start dragging?
                if (!this.isDragging) {
                    if (Math.abs(event.dragDeltaX) >= this.dragStartThreshold ||
                        Math.abs(event.dragDeltaY) >= this.dragStartThreshold) {
                        this.isDragging = true;
                        if (this.onMouseDragStart) {
                            event.buttonDown = true;
                            event.type = GestureMouseEvent.MOUSE_DRAG_START;
                            this.onMouseDragStart(event);
                        }
                        if (this.onPan) {
                            this.onPan({
                                x: event.x,
                                y: event.y,
                                transX: event.dragDeltaX,
                                transY: -event.dragDeltaY,
                                gestureState: GestureRecognizerState.BEGAN,
                            });
                        }
                    }
                }
                else if (this.onPan) {
                    this.onPan({
                        x: event.x,
                        y: event.y,
                        transX: event.dragDeltaX,
                        transY: -event.dragDeltaY,
                        gestureState: GestureRecognizerState.CHANGED,
                    });
                }
            }
            else if (this.onPointerHover) {
                this.onPointerHover({ x: event.x, y: event.y });
            }
            if (this.isDragging) {
                if (this.onMouseDrag) {
                    event.buttonDown = true;
                    event.type = GestureMouseEvent.MOUSE_DRAG;
                    this.onMouseDrag(event);
                }
            }
            //else { dispatch mouse move and mouse drag events
            if (this.onMouseMove) {
                event.type = GestureMouseEvent.MOUSE_MOVE;
                this.onMouseMove(event);
            }
            //}
        }
        else if (domEvent.type === GestureMouseEvent.MOUSE_DOWN) {
            // save the mouse down position
            this.mouseDownPosX = event.x;
            this.mouseDownPosY = event.y;
            event.buttonDown = true;
            this.lastMouseDownTimestamp = this.mouseDownTimestamp || 0;
            this.mouseDownTimestamp = domEvent.timeStamp;
            this.elapsedMouseDownTimestamp = this.mouseDownTimestamp - this.lastMouseDownTimestamp;
            if (this.elapsedMouseDownTimestamp < this.doubleClickTiming) {
                this.isDoubleClick = true;
            }
            if (this.onMouseDown) {
                event.type = GestureMouseEvent.MOUSE_DOWN;
                this.onMouseDown(event);
            }
        }
        else if (domEvent.type === GestureMouseEvent.MOUSE_UP) {
            if (this.onMouseUp) {
                event.type = GestureMouseEvent.MOUSE_UP;
                this.onMouseUp(event);
            }
            if (!this.isDragging) {
                if (this.isDoubleClick) {
                    if (this.onMouseDoubleClick) {
                        event.type = GestureMouseEvent.DOUBLE_CLICK;
                        this.onMouseDoubleClick(event);
                    }
                    else if (this.onDoubleTap) {
                        this.onDoubleTap({ x: event.x, y: event.y, taps: 2, gestureState: GestureRecognizerState.ENDED });
                    }
                    this.isDoubleClick = false;
                }
                else if (this.onMouseClick) {
                    event.type = GestureMouseEvent.CLICK;
                    this.onMouseClick(event);
                }
                else if ((event.ctrlKey || event.metaKey) && this.onLongPress) {
                    this.onLongPress({ x: event.x, y: event.y, taps: 1, gestureState: GestureRecognizerState.ENDED });
                }
                else if (this.onTap) {
                    this.onTap({ x: event.x, y: event.y, taps: 1, gestureState: GestureRecognizerState.ENDED });
                }
            }
            else {
                if (this.onMouseDragStop) {
                    event.buttonDown = false;
                    event.type = GestureMouseEvent.MOUSE_DRAG_STOP;
                    this.onMouseDragStop(event);
                }
                if (this.onPan) {
                    event.dragDeltaX = event.x - this.mouseLastPosX;
                    event.dragDeltaY = event.y - this.mouseLastPosY;
                    this.onPan({
                        x: event.x,
                        y: event.y,
                        transX: event.dragDeltaX,
                        transY: -event.dragDeltaY,
                        gestureState: GestureRecognizerState.ENDED,
                    });
                }
                event.dragDeltaX = 0;
                event.dragDeltaY = 0;
                this.isDragging = false;
            }
        }
        else if (domEvent.type === GestureMouseEvent.MOUSE_WHEEL) {
            this.doPinch(event);
            if (this.onMouseWheel) {
                event.type = GestureMouseEvent.MOUSE_WHEEL;
                this.onMouseWheel(event);
            }
        }
        else if (domEvent.type === 'DOMMouseScroll') {
            this.doPinch(event);
            if (this.onMouseWheel) {
                event.type = GestureMouseEvent.MOUSE_WHEEL;
                event.wheelDelta = domEvent.detail * -1;
                this.onMouseWheel(event);
            }
        }
        else if (domEvent.type === GestureMouseEvent.MOUSE_OVER) {
            if (this.onMouseOver) {
                event.type = GestureMouseEvent.MOUSE_OVER;
                this.onMouseOver(event);
            }
        }
        else if (domEvent.type === GestureMouseEvent.MOUSE_OUT) {
            if (this.onMouseOut) {
                event.type = GestureMouseEvent.MOUSE_OUT;
                this.onMouseOut(event);
            }
        }
    };
    Gestures.prototype.doPinch = function (event) {
        // NOTE(mikcol): moved null handling from caller to here
        if (!this.onPinch) {
            return;
        }
        var scale;
        // NOTE(mikcol): legacy, never READ from
        // TODO(mikcol): is this a bug? look below for the writes
        //let gestureState;
        // NOTE(mikcol): legacy defined self, isn't used
        //let self = this;
        if (event.wheelDelta > 0) {
            scale = 1.1;
        }
        else {
            scale = 0.9;
        }
        if (!this.isWheeling) {
            this.isWheeling = true;
            // NOTE(mikcol): values are never read
            //gestureState = GestureRecognizerState.BEGAN;
        }
        else {
            clearInterval(this.wheelTimer);
            // NOTE(mikcol): values are never read
            //gestureState = GestureRecognizerState.CHANGED;
        }
        var startOffX = 0;
        var startOffY = 0;
        var endOffX = 0;
        var endOffY = 0;
        // 5,6 stolen from MouseInputController.cpp.  Seemes to work for now...
        if (event.wheelDelta >= 0) {
            startOffX = 5;
            endOffX = 6;
        }
        else {
            startOffX = 6;
            endOffX = 5;
        }
        var pt = {
            x: event.x,
            y: event.y,
        };
        //pt = this.getRelativeMouseCoordinates( event );
        var pntAX = pt.x - startOffX;
        var pntAY = pt.y - startOffY;
        var pntBX = pt.x + startOffX;
        var pntBY = pt.y + startOffY;
        this.onPinch({
            x: pntAX,
            y: pntAY,
            x2: pntBX,
            y2: pntBY,
            scale: scale,
            velocity: 0,
            gestureState: GestureRecognizerState.BEGAN,
        });
        pntAX = pt.x - endOffX;
        pntAY = pt.y - endOffY;
        pntBX = pt.x + endOffX;
        pntBY = pt.y + endOffY;
        this.onPinch({
            x: pntAX,
            y: pntAY,
            x2: pntBX,
            y2: pntBY,
            scale: scale,
            velocity: 0,
            gestureState: GestureRecognizerState.CHANGED,
        });
        this.onPinch({
            x: pntAX,
            y: pntAY,
            x2: pntBX,
            y2: pntBY,
            scale: scale,
            velocity: 0,
            gestureState: GestureRecognizerState.ENDED,
        });
    };
    // TODO(mikcol): is this actually used anywhere?
    Gestures.prototype.doTouchEvent = function (domEvent) {
        // TODO: Handle touch events
        var tEvent = new TouchEvent();
        if (!domEvent) {
            domEvent = window.event;
        }
        // NOTE(mikcol): don't actually know if this works :/
        this.event = domEvent;
        this.setTouchPosition(domEvent, tEvent);
    };
    Gestures.prototype.touchToMouse = function (event) {
        // allow default multi-touch gestures to work (pinch, etc.)
        if (event.touches.length > 1) {
            return;
        }
        var touch = event.changedTouches[0];
        var type = '';
        switch (event.type) {
            case 'touchstart':
                type = 'mousedown';
                break;
            case 'touchmove':
                type = 'mousemove';
                break;
            case 'touchend':
                type = 'mouseup';
                break;
            default:
                return;
        }
        var simulatedEvent = document.createEvent('MouseEvent');
        simulatedEvent.initMouseEvent(type, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
        touch.target.dispatchEvent(simulatedEvent);
        event.preventDefault();
    };
    Gestures.prototype.getEventPoint = function (domEvent) {
        return {
            x: domEvent.offsetX,
            y: domEvent.offsetY,
        };
    };
    Gestures.prototype.domToLocal = function (point) {
        var pt = { x: point.x, y: point.y };
        if (this.invertY) {
            if (this.element.pixelRatio) {
                // tslint:disable-next-line:no-unsafe-any
                pt.y = this.element.clientHeight / this.element.pixelRatio - pt.y;
            }
            else {
                pt.y = this.element.clientHeight - pt.y;
            }
        }
        return pt;
    };
    Gestures.prototype.setMousePosition = function (domEvent, gEvent) {
        var localPt = this.domToLocal(this.getEventPoint(domEvent));
        this.mousePosX = gEvent.x = localPt.x;
        this.mousePosY = gEvent.y = localPt.y;
    };
    Gestures.prototype.setTouchPosition = function (domEvent, gEvent) {
        // NOTE(mikcol): shut tsc up
        domEvent = domEvent;
        gEvent = gEvent;
        //			if (domEvent.touches !== undefined && domEvent.touches.length === 1) {// Only deal with
        //				// one finger
        //				let touch = domEvent.touches[0];
        //				let elementPos = this.getCanvasPos();
        //
        //				// Get the information for finger #1
        //				gEvent.x = touch.clientX - elementPos.x + window.pageXOffset;
        //				gEvent.y = touch.clientY - elementPos.y + window.pageYOffset;
        //				if (this.invertY) {
        //					gEvent.y = this.element.height - gEvent.y;
        //				}
        //
        //				this.touchPosX = gEvent.x;
        //				this.touchPosY = gEvent.y;
        //			}
    };
    Gestures.prototype._calculateTotalOffset = function () {
        if (!this.stylesValid) {
            this._calculateStyles();
            this.stylesValid = true;
        }
        var totalOffsetX = 0;
        var totalOffsetY = 0;
        var elem = this.element;
        while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
            totalOffsetX += elem.offsetLeft - elem.scrollLeft;
            totalOffsetY += elem.offsetTop - elem.scrollTop;
            elem = elem.offsetParent;
        }
        // Add padding and border style widths to offset
        // Also add the <html> offsets in case there's a position:fixed bar (like the stumbleupon bar)
        // This part is not strictly necessary, it depends on your styling
        totalOffsetX += this.stylePaddingLeft + this.styleBorderLeft + this.htmlLeft;
        totalOffsetY += this.stylePaddingTop + this.styleBorderTop + this.htmlTop;
        this.totalOffset = { left: totalOffsetX, top: totalOffsetY };
        return this.totalOffset;
    };
    Gestures.prototype._calculateStyles = function () {
        var element = this.element;
        if (document.defaultView && document.defaultView.getComputedStyle) {
            this.stylePaddingLeft =
                parseInt(document.defaultView.getComputedStyle(element, null).paddingLeft, 10) || 0;
            this.stylePaddingTop =
                parseInt(document.defaultView.getComputedStyle(element, null).paddingTop, 10) || 0;
            this.styleBorderLeft =
                parseInt(document.defaultView.getComputedStyle(element, null).borderLeftWidth, 10) || 0;
            this.styleBorderTop =
                parseInt(document.defaultView.getComputedStyle(element, null).borderTopWidth, 10) || 0;
        }
        var html = document.body.parentNode;
        this.htmlTop = html.offsetTop;
        this.htmlLeft = html.offsetLeft;
    };
    // TODO(mikcol): is this used anywhere anymore?
    Gestures.prototype.getRelativeMouseCoordinates = function (e) {
        // NOTE(mikcol): legacy didn't use return value
        var totalOffset = this._calculateTotalOffset();
        var mouseX = e.pageX - totalOffset.left;
        var mouseY = e.pageY - totalOffset.top;
        return { x: mouseX, y: mouseY };
    };
    Gestures.prototype.toString = function (event) {
        var s = '';
        // TODO(mikcol): does this actually work? and is it used?
        // tslint:disable:no-unsafe-any
        for (var key in event) {
            if (event.hasOwnProperty(key)) {
                var obj = event[key];
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        s += '\n' + prop + ': ' + String(obj[prop]);
                    }
                }
            }
        }
        // tslint:enable:no-unsafe-any
        // NOTE(mikcol): was `return 's';` in legacy
        return s;
    };
    return Gestures;
}());
export default Gestures;
